import { Banner } from '@dropbox/dig-components/banner';
import { useAtomValue } from 'jotai';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { readyErrorAtom } from 'signer-app/signer-experience/auto-save-signer-experience/use-signer-ready';

export function ReadyErrorBanner() {
  const hasReadyError = useAtomValue(readyErrorAtom);

  if (!hasReadyError) {
    return null;
  }

  return (
    <Banner type="alert">
      <Banner.Message>
        <FormattedMessage
          id="f9d28d1dae54063f069447ffebd102e9f2187cbfa7544c4032e9e1e48e7161f9"
          defaultMessage="Something went wrong while loading the document."
          description="Error message shown when the signer ready request fails unexpectedly"
        />
      </Banner.Message>
    </Banner>
  );
}
